import { render } from "./AnnexAlarmItemTile.vue?vue&type=template&id=27c1bafe&ts=true"
import script from "./AnnexAlarmItemTile.vue?vue&type=script&lang=ts"
export * from "./AnnexAlarmItemTile.vue?vue&type=script&lang=ts"

import "./AnnexAlarmItemTile.vue?vue&type=style&index=0&id=27c1bafe&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__